import { MuiAlert } from '@fox/atoms/src/mui-alert/index';
import { Skeleton } from '@fox/atoms/src/skeleton/index';
import { IBlockDefinition, IBlockProps } from '@fox/blocks/contracts/block';
import { useQuery } from '@tanstack/react-query';
import { ACCOUNT_BLOCK_TYPE } from '../../../form-block-types';
import { useFormFinancialContext } from '../../form-financial-context/form-financial-context';
import { IField } from '../../form-root/contracts';
import { useFormRuntimeContext } from '../../form-runtime-context/form-runtime-context';

export function AccountRuntime({ id, token, props }: IBlockProps<IField> & { token?: string }) {
	const { getAccountInfo } = useFormFinancialContext();
	const { target, answerQuestion } = useFormRuntimeContext();
	const { isLoading, data, error } = useQuery({
		queryFn: async () => {
			const info = await getAccountInfo({ token, ownerId: target?.ownerId, ownerType: target?.ownerType });
			if (info?.success) {
				// This is better than a useEffect; we can update the result here.
				answerQuestion({
					answer: {
						answerBoolean: true
					},
					questionName: props.name,
					data: {
						lineItems: info?.account?.lineItems?.map(l => ({ ...l, immediatePayment: true })) ?? []
					}
				});
			}
			return info;
		},
		queryKey: ['account-info', id]
	});

	if (isLoading || !data) return <Skeleton />;
	if (data?.success === false) return <MuiAlert severity="info">{data.message}</MuiAlert>;
	if (error) return <MuiAlert severity="error">Error querying outstanding balance</MuiAlert>;

	return <></>;
}

export const buildAccountBlockRuntime = (token?: string): IBlockDefinition => {
	return {
		type: ACCOUNT_BLOCK_TYPE,
		Component: pp => {
			return <AccountRuntime {...pp} token={token} />;
		}
	};
};
